'use client'
import { useState, useEffect, useCallback } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname, useRouter } from 'next/navigation'
import logoImg from '@/assets/logo-light.webp'
import { useCart } from '@/context/CartContext'
import { IconCart } from '@/icons'
import { COMPANY, NAV_PAGES } from '@/lib/site'

export default function Header() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const pathname = usePathname()
  const router = useRouter()
  const { count, openCart } = useCart()

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 24)
    on()
    window.addEventListener('scroll', on, { passive: true })
    return () => window.removeEventListener('scroll', on)
  }, [])

  // Close menu on any scroll
  useEffect(() => {
    if (!menuOpen) return
    const on = () => setMenuOpen(false)
    window.addEventListener('scroll', on, { passive: true, once: true })
    return () => window.removeEventListener('scroll', on)
  }, [menuOpen])

  // Prevent body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [menuOpen])

  const onNav = useCallback((href) => {
    setMenuOpen(false)
    router.push(href)
  }, [router])

  const isActive = (href) => href === '/' ? pathname === '/' : pathname === href || pathname.startsWith(`${href}/`)

  return (
    <>
      <header className={`hdr ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
        <div className="container hdr-inner">
          <Link href="/" className="brand" onClick={() => setMenuOpen(false)}>
            <Image src={logoImg} alt="СК-АКВА" className="brand-logo" height={56} />
          </Link>
          <nav className="nav">
            {NAV_PAGES.map(i => (
              <Link key={i.href} href={i.href}
                 className={isActive(i.href) ? 'active' : ''}>
                {i.label}
              </Link>
            ))}
          </nav>
          <div className="hdr-right">
            <button className="cart-btn" onClick={openCart} aria-label="Корзина">
              <IconCart width="20" height="20" />
              {count > 0 && <span className="cart-badge">{count > 99 ? '99+' : count}</span>}
            </button>
            <a className="hdr-phone" href={`tel:${COMPANY.phone}`}>
              <span className="lbl">Позвонить нам</span>
              {COMPANY.phoneDisplay}
            </a>
            <button className="btn btn-primary hdr-cta" onClick={() => onNav('/contacts')}>
              Связаться с нами
            </button>
            <button
              className={`burger ${menuOpen ? 'open' : ''}`}
              onClick={() => setMenuOpen(v => !v)}
              aria-label={menuOpen ? 'Закрыть меню' : 'Открыть меню'}
              aria-expanded={menuOpen}
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </header>

      {menuOpen && (
        <div className="mobile-nav-backdrop" onClick={() => setMenuOpen(false)}>
          <div className="mobile-nav" onClick={e => e.stopPropagation()}>
            {NAV_PAGES.map(i => (
              <Link key={i.href} href={i.href}
                 className={`mobile-nav-link ${isActive(i.href) ? 'active' : ''}`}
                 onClick={() => setMenuOpen(false)}>
                {i.label}
              </Link>
            ))}
            <div className="mobile-nav-footer">
              <a className="mobile-nav-phone" href={`tel:${COMPANY.phone}`}>
                {COMPANY.phoneDisplay}
              </a>
              <button className="btn btn-primary" style={{width:'100%',justifyContent:'center'}} onClick={() => onNav('/contacts')}>
                Связаться с нами
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
